const AddressIcon = (props: any) => (
	<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12.0004 23.0002C10.0424 21.4172 9.91743 16.2082 13.0004 15.0002C14.6364 14.3592 15.1664 17.9372 18.3754 17.0422C18.9964 16.8692 20.4584 17.7502 19.9264 19.0942"
			stroke="#333333"
			strokeWidth={2}
			strokeMiterlimit={10}
		/>
		<path
			d="M6.24456 4.82129C6.87556 5.28729 7.41856 5.85729 7.88256 6.63529C8.28756 7.31429 9.18856 9.20529 8.36356 10.2733C7.42956 11.4803 4.72656 11.8873 4.72656 13.0003C4.72656 13.8373 5.91156 14.7933 6.54456 15.7273C7.49656 17.1323 7.06356 18.4943 6.54456 19.3633C6.27556 19.8143 5.82356 20.1793 5.34656 20.4663"
			stroke="#333333"
			strokeWidth={2}
			strokeMiterlimit={10}
		/>
		<path
			d="M21.8 11C21.931 11.646 22 12.315 22 13C22 18.523 17.523 23 12 23C6.477 23 2 18.523 2 13C2 7.477 6.477 3 12 3C12.494 3 12.98 3.036 13.455 3.105"
			stroke="#333333"
			strokeWidth={2}
			strokeMiterlimit={10}
		/>
		<path d="M17 9V12" stroke="#333333" strokeWidth={2} strokeMiterlimit={10} strokeLinecap="square" />
		<path
			d="M17 9C19.2091 9 21 7.20914 21 5C21 2.79086 19.2091 1 17 1C14.7909 1 13 2.79086 13 5C13 7.20914 14.7909 9 17 9Z"
			stroke="#333333"
			strokeWidth={2}
			strokeMiterlimit={10}
			strokeLinecap="square"
		/>
	</svg>
);
export default AddressIcon;
